import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { CpfCnpjPipe } from './CpfCnpjPipe';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    CpfCnpjPipe,
  ],
  exports: [
    CpfCnpjPipe,
  ],
})
export class CpfCnpjPipeModule { }